import { Iuser, Result } from '@/typings';
import { post } from '@/util';

/** 校验旧密码 */
export const valiOldPwd = (params: { username: string; password: string }) => {
	return new Promise<void>((resolve, reject) => {
		post(
			`/auth/user/validateOldPwd`,
			params,
			(result: Result<string>) => {
				const { code, data } = result;
				if (code === 200 && data === 'true') {
					resolve();
				} else {
					reject();
				}
			},
			reject,
		);
	});
};

/** 修改密码 */
export const updatePwd = (params: { username: string; password: string }) => {
	return new Promise<void>((resolve, reject) => {
		post(
			'/auth/user/update',
			params,
			(result: Result<void>) => {
				const { code } = result;
				if (code === 200) {
					resolve();
				} else {
					reject();
				}
			},
			reject,
		);
	});
};

/** 保存用户 */
export function saveUser(params: Partial<Iuser>) {
	return new Promise<void>((resole, reject) => {
		post(
			'/auth/user/update',
			params,
			(result: Result<void>) => {
				const { code } = result;
				if (code === 200) {
					resole();
				} else {
					reject();
				}
			},
			() => {
				reject();
			},
			true,
		);
	});
}
